import { lazy } from "react";

import { ROUTES_PATHS } from "@/configs/paths";

export const ROUTES = [
	{
		path: ROUTES_PATHS.HOME,
		page: lazy(() => import("../pages/Home")),
	},
	{
		path: ROUTES_PATHS.LOGIN,
		page: lazy(() => import("../pages/Login/index")),
	},
	{
		path: ROUTES_PATHS.LUCKYDRAW,
		page: lazy(() => import("../pages/LuckyDraw/index")),
	},
	{
		path: ROUTES_PATHS.QR,
		page: lazy(() => import("../pages/QR/QR")),
	},
];
